








































































































































import { Vue, Component, Watch, Ref, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import BoundInstances from "../../components/admin/BoundInstances.vue";
import { getInstanceHierarchyInstanceId } from "@futuri/cloudsso-client/src/instanceUtils";
import { notUndefined } from "@futuri/cloudsso-client/src/util";
import {
  ProductInstanceResult,
  AdminUserResult,
  INSTANCE_COMPANY,
  INSTANCE_CLUSTER,
  INSTANCE_STATION,
  USER_INSTANCE_LEVEL_COMPANY,
  USER_INSTANCE_LEVEL_REGION,
  USER_INSTANCE_LEVEL_MARKET,
  USER_INSTANCE_LEVEL_STATION
} from "@futuri/cloudsso-client";

@Component({
  components: {
    BoundInstances
  }
})
export default class UserProductSettings extends Vue {
  // @Getter('cachedInstances', { namespace: 'adminUserPost' })
  // instances?: ProductInstanceResult[]

  @Prop()
  productName!: string;

  @Prop()
  instances?: ProductInstanceResult[];

  @Prop()
  productEnabled?: boolean;

  @Getter("currentUser", { namespace: "adminUserPost" })
  currentUser?: AdminUserResult;
  @Getter("currentCompany", { namespace: "adminUserPost" })
  currentCompany?: string;
  @Getter("selectedBinding", { namespace: "adminUserPost" })
  selectedBinding?: string;
  @Getter("selectedStation", { namespace: "adminUserPost" })
  selectedStation?: ProductInstanceResult;

  @Getter("hasSelectedBinding", { namespace: "adminUserPost" })
  hasSelectedBinding?: boolean;
  @Getter("selectedBindingInstance", { namespace: "adminUserPost" })
  selectedBindingInstance?: ProductInstanceResult;

  @Action("clearSelectedBinding", { namespace: "adminUserPost" })
  clearSelectedBinding!: () => void;

  @Action("setSelectedStation", { namespace: "adminUserPost" })
  setSelectedStation!: (station?: string) => Promise<void>;

  @Action("fetchInstances", { namespace: "adminUserPost" })
  fetchInstances!: () => Promise<void>;

  @Ref("productEnabledCheckbox")
  productEnabledCheckbox!: HTMLInputElement;

  productCurrentlyEnabled = false;

  changeEnabled() {
    console.log("change enabled");
    const { checked } = this.productEnabledCheckbox;
    this.productCurrentlyEnabled = checked;
  }

  @Getter("hasPost")
  hasPost?: boolean;

  @Ref("actionButtons")
  actionButtons: any;
  @Ref("saveButton")
  saveButton: any;

  @Watch("currentUser")
  async onChangeUser(_: AdminUserResult) {
    await this.loadInstances();
  }

  get accessLevelLabel() {
    const productName = this.productName;
    return `User's ${productName} Access Level`;
  }

  get defaultInstanceLabel() {
    const productName = this.productName;
    return `User's Default ${productName} Instance`;
  }

  get displayStation() {
    return this.selectedStation?.name?.toUpperCase() ?? "No Station";
  }

  get displayBinding() {
    const { currentUser, selectedBindingInstance } = this;
    if (!currentUser || !selectedBindingInstance) {
      return "";
    }

    const label = `${
      currentUser?.email
    } - ${selectedBindingInstance?.name?.toUpperCase()}`;
    return label;
  }

  get displayEmail() {
    return this.currentUser?.email;
  }
  get displayCompany() {
    return this.currentCompany;
  }

  get displayEditWarning() {
    const { selectedBindingInstance } = this;
    if (!selectedBindingInstance) {
      return "";
    }

    const { instanceType, name } = selectedBindingInstance;
    if (
      instanceType === INSTANCE_COMPANY ||
      instanceType === INSTANCE_CLUSTER
    ) {
      return `Note: changes made here will affect all ${name} access for the selected user.`;
    }

    return "";
  }

  get displaySaveLabel() {
    const productName = this.productName;
    const instanceType = this.selectedBindingInstance?.instanceType;
    if (instanceType === INSTANCE_COMPANY) {
      return `Save Company ${productName} Settings`;
    } else {
      return `Save User ${productName} Settings`;
    }
  }

  get companyOptions() {
    return [{ label: "iHeartMedia", value: "iHeartMedia" }];
  }

  get isNotStation() {
    return this.selectedBindingInstance?.instanceType !== INSTANCE_STATION;
  }

  get accessLevels() {
    return [
      { label: "User", value: "user" },
      { label: "Admin", value: "admin" },
      { label: "Sales (air check)", value: "sales" }
    ];
  }

  get userTypes() {
    return [
      { label: "Full", value: "full" },
      { label: "Logger Only", value: "loggerOnly" },
      { label: "Podcasting Only", value: "podcastingOnly" }
    ];
  }

  get instanceAccessLevels() {
    return [
      { label: "Company Admin", value: USER_INSTANCE_LEVEL_COMPANY },
      { label: "Regional", value: USER_INSTANCE_LEVEL_REGION },
      { label: "Market (Cluster)", value: USER_INSTANCE_LEVEL_MARKET },
      { label: "Station", value: USER_INSTANCE_LEVEL_STATION }
    ];
  }

  get defaultInstanceOptions() {
    interface ListOption {
      label: string;
      value: string;
    }

    const instances = this.instances ?? [];
    const instOpts: ListOption[] = instances.map(
      (inst: ProductInstanceResult) => {
        const { instanceType, instanceId, name } = inst;
        const label =
          instanceType === INSTANCE_STATION
            ? `${name.toUpperCase()} (Station)`
            : name;
        return { label, value: instanceId };
      }
    );

    const genOpts: ListOption[] = [
      { label: "(Use General Setting)", value: "generalSetting" },
      { label: "(Last Visited)", value: "last" }
    ];

    return genOpts.concat(instOpts);
  }

  // get boundInstances() {
  //   // const allInstances = this.availableInstances ?? []
  //   // const availableInstances = this.availableInstances ?? [];

  //   const instances = this.instances ?? [];
  //   const stations = new Set(this.currentUser?.postDetails?.stations ?? []);

  //   // Get stations accessible by the currently selected user
  //   const userInstances = instances.filter(
  //     inst => inst.instanceType === INSTANCE_STATION && stations.has(inst.name)
  //   );

  //   // Collect company and cluster for those stations only
  //   const companyInstanceIds = userInstances.map(inst =>
  //     getInstanceHierarchyInstanceId(inst, INSTANCE_COMPANY)
  //   );
  //   const clusterInstanceIds = userInstances.map(inst =>
  //     getInstanceHierarchyInstanceId(inst, INSTANCE_CLUSTER)
  //   );
  //   // const stationInstanceIds = userInstances?.filter(inst => inst.instanceType === INSTANCE_STATION ? inst.instanceId : undefined).filter(notUndefined)
  //   const stationInstanceIds = userInstances.map(inst =>
  //     getInstanceHierarchyInstanceId(inst, INSTANCE_STATION)
  //   );
  //   const set = new Set(
  //     [
  //       ...companyInstanceIds,
  //       ...clusterInstanceIds,
  //       ...stationInstanceIds
  //     ].filter(notUndefined)
  //   );

  //   // Filter the original list (available to the logged in user) by those criteria
  //   const matching = instances?.filter(inst => set.has(inst.instanceId));
  //   return matching;
  // }

  // get instanceFilter() {
  //   const alwaysTrue = (_: ProductInstanceResult) => true
  //   if (!this.currentUser) {
  //     return alwaysTrue
  //   }
  //   const stations = this.currentUser.postDetails?.stations
  //   if (!stations?.length) {
  //     return alwaysTrue
  //   }
  //   const safeMatch = (s: string) => s?.toLowerCase()?.replace(/[^a-z]/g, "")
  //   const set = new Set(stations.map(safeMatch))

  //   return (inst: ProductInstanceResult) => {
  //     const { instanceType, name } = inst
  //     if (instanceType !== INSTANCE_STATION) {
  //       return true
  //     }
  //     const safeName = safeMatch(name)
  //     return set.has(safeName)
  //   }
  // }

  async handleStation(event: Event) {
    const station = (event.currentTarget as HTMLSelectElement).value;
    await this.setSelectedStation(station);
  }

  async loadInstances() {
    console.log("fetching instances");
    await this.fetchInstances();
  }

  async mounted() {
    // Product enable
    this.productCurrentlyEnabled = !!this.productEnabled;

    // await this.$store.dispatch('admin/fetchAdminUsers', { root: true })
    await this.loadInstances();
    console.log("mounted");

    // TODO: replace with onClick in template
    const buttons = this.actionButtons;
    if (buttons) {
      buttons
        .querySelector("fm-button-primary")
        .addEventListener("click", (_event: MouseEvent) => {
          console.log("click");
          this.saveSettings();
        });
      buttons
        .querySelector("fm-button-tertiary")
        .addEventListener("click", (_event: MouseEvent) => {
          console.log("click");
          this.discardSettings();
        });
    }
  }

  // Actions

  saveSettings() {
    const { saveButton } = this;
    saveButton.success = true;
    setTimeout(() => {
      saveButton.success = false;
      this.clearSelectedBinding();
    }, 600);
  }

  discardSettings() {
    setTimeout(() => {
      this.clearSelectedBinding();
    }, 300);
  }
}
